import React, { useState, useEffect } from 'react';
import { MdArrowBack, MdSecurity, MdCheckCircle } from 'react-icons/md';
import { useNavigate } from 'react-router-dom'; // useNavigate add kiya
import { db } from "../firebase";
import { ref, set, onValue } from "firebase/database";
import Swal from 'sweetalert2';
import './PaymentMethod.css';

const PaymentMethod = () => {
    const [walletName, setWalletName] = useState('');
    const [address, setAddress] = useState('');
    const [isBound, setIsBound] = useState(false);
    const [loading, setLoading] = useState(true);
    
    const navigate = useNavigate(); // Navigation initialize
    const savedUser = JSON.parse(localStorage.getItem('user'));

    useEffect(() => {
        if (savedUser?.username) {
            const walletRef = ref(db, `users/${savedUser.username}/paymentMethod`);
            onValue(walletRef, (snapshot) => {
                const data = snapshot.val();
                if (data) {
                    setWalletName(data.walletName);
                    setAddress(data.address);
                    setIsBound(true);
                }
                setLoading(false);
            });
        }
    }, [savedUser.username]);

    // Back function jo history check karega
    const handleBack = () => {
        if (window.history.length > 1) {
            navigate(-1); // Pichle page par wapas jayega (Mine ya Home)
        } else {
            navigate('/'); // Agar history nahi hai to Home par
        }
    };

    const handleBind = async () => {
        if (!walletName || !address) {
            return Swal.fire('Error', 'Please fill all fields', 'error');
        }

        if (!address.toUpperCase().startsWith('T')) {
            return Swal.fire({
                icon: 'error',
                title: 'Invalid Address',
                text: 'Address must start with "T"',
                confirmButtonColor: '#f3ba2f'
            });
        }

        try {
            await set(ref(db, `users/${savedUser.username}/paymentMethod`), {
                walletName: walletName,
                address: address,
                network: 'TRC-20',
                boundAt: new Date().toISOString()
            });
            
            Swal.fire({
                icon: 'success',
                title: 'Wallet Bound!',
                text: 'Your withdrawal address is now locked.',
                timer: 2000,
                showConfirmButton: false
            });
        } catch (error) {
            Swal.fire('Error', error.message, 'error');
        }
    };

    if (loading) return <div className="loading-simple">Loading...</div>;

    return (
        <div className="payment-method-wrapper">
            <div className="pm-nav">
                <MdArrowBack onClick={handleBack} className="nav-icon" />
                <span>Payment Method</span>
                <div className="nav-spacer"></div>
            </div>

            <div className="pm-container">
                <div className="pm-info-card">
                    <MdSecurity size={40} color="#f3ba2f" />
                    <h4>Secure Your Withdrawals</h4>
                    <p>Once a wallet is bound, it cannot be changed for security reasons.</p>
                </div>

                <div className="pm-form">
                    <div className="pm-input-group">
                        <label>Wallet Name</label>
                        <input 
                            type="text" 
                            placeholder="e.g. Binance, Trust Wallet" 
                            value={walletName}
                            onChange={(e) => setWalletName(e.target.value)}
                            disabled={isBound}
                        />
                    </div>

                    <div className="pm-input-group">
                        <label>Network (Fixed)</label>
                        <div className="fixed-network">TRC-20</div>
                    </div>

                    <div className="pm-input-group">
                        <label>TRC-20 Address</label>
                        <input 
                            type="text" 
                            placeholder="Must start with 'T'..." 
                            value={address}
                            onChange={(e) => setAddress(e.target.value)}
                            disabled={isBound}
                        />
                    </div>

                    {!isBound ? (
                        <button className="pm-confirm-btn" onClick={handleBind}>
                            CONFIRM BINDING
                        </button>
                    ) : (
                        <div className="bound-status">
                            <MdCheckCircle size={20} />
                            Wallet Bound Successfully
                        </div>
                    )}
                </div>

                <div className="pm-notes">
                    <h5>Important:</h5>
                    <ul>
                        <li>Verify your address carefully.</li>
                        <li>TRC-20 addresses always start with a capital 'T'.</li>
                        <li>If you need to change the address, contact support.</li>
                    </ul>
                </div>
            </div>
        </div>
    );
};

export default PaymentMethod;